module.exports = __webpack_public_path__ + "public/img/ico-chart-co2.f1647148.svg";